import { render, staticRenderFns } from "./BusinessRoles.vue?vue&type=template&id=41ff849e&"
import script from "./BusinessRoles.vue?vue&type=script&lang=js&"
export * from "./BusinessRoles.vue?vue&type=script&lang=js&"
import style0 from "./BusinessRoles.vue?vue&type=style&index=0&id=41ff849e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports